var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4698_3351)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.501 19.5811C33.501 22.0944 32.4995 24.3693 30.881 26.0135H30.9028L26.6078 30.3917C25.9119 31.1014 25.5208 32.0638 25.5208 33.0673V33.4865C25.5208 34.0612 25.0637 34.527 24.5 34.527C23.9364 34.527 23.4793 34.0612 23.4793 33.4865V33.0286C23.4793 32.048 23.1059 31.1057 22.4379 30.4003L18.2829 26.0135H18.3046C16.6861 24.3693 15.6846 22.0944 15.6846 19.5811C15.6846 14.5657 19.6729 10.5 24.5928 10.5C29.5127 10.5 33.501 14.5657 33.501 19.5811ZM24.5928 21.8514C25.8227 21.8514 26.8199 20.8349 26.8199 19.5811C26.8199 18.3272 25.8227 17.3108 24.5928 17.3108C23.3629 17.3108 22.3658 18.3272 22.3658 19.5811C22.3658 20.8349 23.3629 21.8514 24.5928 21.8514Z",
    fill: "#0F90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5225 29.0813C13.8867 28.1432 14.7761 27.527 15.7658 27.527H16.7982L19.0252 29.4189H15.7658C15.5374 29.4189 15.3321 29.5611 15.2481 29.7776L12.8973 35.8316C12.7526 36.2042 13.0219 36.6081 13.415 36.6081H35.585C35.9781 36.6081 36.2474 36.2042 36.1027 35.8316L33.7519 29.7776C33.6679 29.5611 33.4626 29.4189 33.2342 29.4189H30.346L32.3875 27.527H33.2342C34.2239 27.527 35.1133 28.1432 35.4775 29.0813L37.8283 35.1353C38.4551 36.7497 37.2882 38.5 35.585 38.5H13.415C11.7118 38.5 10.5449 36.7497 11.1717 35.1353L13.5225 29.0813Z",
    fill: "#0F90FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4698_3351"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1edfa7dc10a938c6abf938d5b3ab3042.svg";
export { ForwardRef as ReactComponent };